package pwgs.ui.scenes.acceptinvitationscene

import kotlinx.browser.window
import visage.core.AComponent
import visage.core.Components
import visage.core.AScene
import visage.ds.components.Button
import visage.ds.components.ETextStyles
import visage.ds.components.Modal
import visage.ds.components.Text
import visage.ds.utils.ETextAlign

class MAcceptInvitationScene(props: AcceptInvitationSceneProps) : AScene<AcceptInvitationSceneProps, AcceptInvitationSceneModel, AcceptInvitationSceneState, AcceptInvitationControllerFe>(props) {

    override fun createController() : AcceptInvitationControllerFe {
        return AcceptInvitationControllerFe(props, this)
    }

    override fun initState() : AcceptInvitationSceneState {
        return AcceptInvitationSceneState()
    }

    override fun Components.render(children: List<AComponent<*>>) {
        val m = this@MAcceptInvitationScene.model
        Modal("Accept invitation") {
            isLoading = m.isLoading
            if (!m.isLoading && !m.isInvitationAccepted) {
                error = "Invitation is invalid or expired!"
            }
            if (m.isLoading) {
                Text("Accepting invitation...", ETextStyles.Normal, true) {
                    textAlign = ETextAlign.CENTER
                }
            } else {
                if (m.isInvitationAccepted) {
                    Text("Success", ETextStyles.Normal, true) {
                        textAlign = ETextAlign.CENTER

                    }
                    Button("Go to project list") {
                        onClick = { window.location.href = "/app/index.vsg"}
                    }
                } else {
                    Button("Go to project list") {
                        onClick = { window.location.href = "/app/index.vsg"}
                    }
                }
            }
        }
    }
}

class AcceptInvitationSceneState {

}

fun Components.AcceptInvitationScene(props: AcceptInvitationSceneProps) = this.registerComponent(MAcceptInvitationScene(props), {})
